import {
    GET_POSTS,
    GET_POST_BY_ID,
    CREATE_POST,
    UPDATE_POST,
    DELETE_POST
} from '../actions/post';

const initialState = {
    posts: [],
    loading: false,
    error: null
};

const postReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_POSTS:
            return {
                ...state,
                posts: action.payload,
                loading: false,
                error: null
            };
        case GET_POST_BY_ID:
            return {
                ...state,
                post: action.payload,
                loading: false,
                error: null
            };
        case CREATE_POST:
            return {
                ...state,
                posts: [...state.posts, action.payload],
                loading: false,
                error: null
            };
        case UPDATE_POST:
            return {
                ...state,
                posts: state.posts.map((post: any) =>
                    post._id === action.payload._id ? action.payload : post
                ),
                loading: false,
                error: null
            };
        case DELETE_POST:
            return {
                ...state,
                posts: state.posts.filter((post: any) => post._id !== action.payload),
                loading: false,
                error: null
            };
        default:
            return state;
    }
};

export default postReducer;
